/**
 * PageTracker.jsx
 *
 * Mount this ONCE, right inside your <Router>, above your <Routes>.
 * It automatically fires a page-view + duration track on every route change,
 * so you don't need to add useAnalyticsTracker() to every single page.
 *
 * USAGE in App.jsx:
 *
 *   import { BrowserRouter } from 'react-router-dom';
 *   import { PageTracker } from './components/PageTracker';
 *
 *   function App() {
 *     const { user } = useAuth(); // however you access the logged-in user
 *     return (
 *       <BrowserRouter>
 *         <PageTracker userId={user?.id} />
 *         <Routes>
 *           ...your existing routes, untouched...
 *         </Routes>
 *       </BrowserRouter>
 *     );
 *   }
 */
import { useLocation } from 'react-router-dom';
import { useAnalyticsTracker } from '../hooks/useAnalyticsTracker';

export function PageTracker({ userId }) {
    const location = useLocation();
    // key on pathname so the hook re-fires (and sends duration for the
    // previous page) every time the route changes
    useAnalyticsTracker(userId, location.pathname);
    return null; // renders nothing, just tracks in the background
}